import { ApolloClient, DocumentNode, OperationVariables, TypedDocumentNode, useMutation } from '@apollo/client';
import { useContext } from 'react';
import { UserContext } from '../auth/UserContext';

export const useMutationWithContext = <TData = any, TVariables = OperationVariables>(
    query: DocumentNode | TypedDocumentNode<TData, TVariables>,
    client: ApolloClient<object> = undefined
) => {
    const { activeOrganizationAccount } = useContext(UserContext);

    return useMutation(query, {
        client,
        context: {
            headers: {
                ownerId: activeOrganizationAccount
            }
        }
    });
};
